<div class="products-container">

  <!-- Header -->
  <div class="page-header">
    <h1 class="page-title">Menue Days</h1>

    <div class="header-actions">

      <!-- ✅ Day Select -->
      <select class="day-select" [(ngModel)]="selectedDay" (change)="onDayChange()">
        <option *ngFor="let d of days"  [ngValue]="d.value">{{ d.label }}</option>
      </select>

      <!-- Search -->
      <input
        type="text"
        placeholder="Search products..."
        class="search-input"
        (input)="onSearch($event)"
      />

      <!-- Add -->
      <button class="btn-add-reservation" (click)="pickerOpen = true">
        <span class="btn-icon">➕</span>
        <span class="btn-text">Add New Products To Day</span>
      </button>
    </div>
  </div>

  <!-- Products Table -->
  <div class="products-table">
    <!-- Table Header -->
    <div class="table-header">
      <div class="header-cell image-cell">Image</div>
      <div class="header-cell name-cell">Product Name</div>
      <div class="header-cell">Day Id</div>
      <div class="header-cell">Barcode</div>
      <div class="header-cell">Min</div>
      <div class="header-cell">Allocated Product</div>
      <div class="header-cell">Max</div>
      <div class="header-cell">Allocated</div>
      <div class="header-cell actions-cell">Actions</div>
    </div>

    <!-- Loading State -->
    <div class="loading-overlay" *ngIf="isLoading">
      <div class="spinner"></div>
      <p>Loading products...</p>
    </div>

    <!-- Table Body -->
    <div class="table-body" *ngIf="!isLoading">
      <ng-container *ngFor="let item of filteredProducts">
        <div class="product-row">

          <!-- Image -->
          <div class="cell image-cell">
            <img
              [src]="item.thumbnail_image |ImageUrlPipe"
              [alt]="item.name"
              class="product-image"
              appImageFallback
            />
          </div>

          <!-- Name -->
          <div class="cell name-cell">
            <div class="product-name">{{ item.name }}</div>
            <div class="product-meta">
              <span class="meta-item">
                <span class="meta-label">Price:</span>
                <span class="meta-value">{{ item.stroked_price | currency }}</span>
              </span>
              <span class="meta-item">
                <span class="meta-label">Rating:</span>
                <span class="meta-value">{{ item.rating || 0 }}</span>
              </span>
            </div>
          </div>

    <div class="cell">
  <select
    class="day-select"
    [(ngModel)]="item.menue_day_id"
    (change)="markDirty(item); onQtyChange(item);"
    >

    <option *ngFor="let d of days" [ngValue]="d.value">
      {{ d.label }}
    </option>

  </select>
</div>




          <!-- Barcode -->
          <div class="cell">{{ item.barcode || 'N/A' }}</div>

          <!-- Min -->
          <div class="cell">
            <input
              type="number"
              class="qty-input"
              [(ngModel)]="item.min_qty"
              (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange()"
              min="0"
            />
          </div>

          <!-- Qty -->
          <div class="cell">
            <input
              type="number"
              class="qty-input"
              [(ngModel)]="item.prod_qty"
              (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange()"
              min="0"
            />
          </div>

          <!-- Max -->
          <div class="cell">
            <input
              type="number"
              class="qty-input"
              [(ngModel)]="item.max_qty"
              (ngModelChange)="markDirty(item)"
              (blur)="onQtyChange()"
              min="0"
            />
          </div>

          <!-- Allocated -->
          <div class="cell">
            <span class="allocated-badge" *ngFor="let stk of item.stock">
              <small>{{ stk.stores.name }}</small>
              <strong>{{ stk.alloc_qty }}</strong>
            </span>
          </div>

          <!-- Actions -->
          <div class="cell actions-cell">
            <div class="action-buttons">
              <button class="btn-edit" (click)="openStockModal(item)" title="Transfer Product">
                <i class="fa-duotone fa-solid fa-truck"></i>Transfer
              </button>
            </div>
          </div>

        </div>
      </ng-container>

      <!-- Empty -->
      <div class="empty-state" *ngIf="filteredProducts.length === 0">
        <div class="empty-icon">📦</div>
        <p class="empty-text">No products found</p>
        <p class="empty-subtext">Try adjusting your search or change the day filter.</p>
      </div>
    </div>
  </div>

  <!-- Pagination -->
  <div class="pagination-container" *ngIf="!isLoading && filteredProducts.length > 0">
    <div class="pagination-info">
      Showing <strong>{{ getStartIndex() }}</strong> to <strong>{{ getEndIndex() }}</strong>
      of <strong>{{ totalItems }}</strong> products
    </div>

    <div class="pagination-controls">
      <button
        class="page-btn prev-btn"
        (click)="previousPage()"
        [disabled]="currentPage === 1 || isLoading"
        title="Previous Page"
      >
        ‹
      </button>

      <button
        *ngIf="currentPage > 3"
        class="page-btn page-number"
        (click)="goToPage(1)"
        [disabled]="isLoading"
      >
        1
      </button>

      <span class="ellipsis" *ngIf="currentPage > 3">...</span>

      <button
        *ngFor="let page of getPageNumbers()"
        class="page-btn page-number"
        [class.active]="page === currentPage"
        [disabled]="isLoading"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>

      <span class="ellipsis" *ngIf="currentPage < totalPages - 2">...</span>

      <button
        *ngIf="currentPage < totalPages - 2 && totalPages > 1"
        class="page-btn page-number"
        (click)="goToPage(totalPages)"
        [disabled]="isLoading"
      >
        {{ totalPages }}
      </button>

      <button
        class="page-btn next-btn"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages || isLoading"
        title="Next Page"
      >
        ›
      </button>
    </div>
  </div>

</div>

<!-- Products Modal -->
<app-product-day-picker-modal
  [isOpen]="pickerOpen"
  (close)="pickerOpen = false"
  (saved)="onPickerSaved($event)">
</app-product-day-picker-modal>


<!-- Stock Modal -->
<div class="modal-backdrop" *ngIf="showStockModal">
  <div class="modal">

    <!-- Header -->
    <div class="modal-header">
      <h3>Stock Details - {{ selectedProduct?.name }}</h3>
      <button class="close-btn" (click)="closeStockModal()">✖</button>
    </div>

    <!-- Body -->
    <div class="modal-body">
      <div
        class="stock-row"
        *ngFor="let stk of selectedProduct?.stock; let i = index"
      >
        <div class="stock-info">
          <strong>{{stk.stores.name}}</strong>
          <span>Requested: {{ stk.alloc_qty }}</span>
        </div>

        <div class="stock-inputs">
          <!-- Input 1 -->
          <span>Allocated</span>
          <input
            type="number"
            class="stock-input"
            [(ngModel)]="stk.alloc_qty"
            placeholder="Allocated"
            [min]="stk.alloc_qty"
          />
          
          <!-- Input 2 -->
          <span>Stocked</span>
          <input
            type="number"
            class="stock-input"
            placeholder="Stocked"
            #stock_qty
            [min]="stk.alloc_qty"
            [value]="stk.alloc_qty"
          />
        </div>
      </div>
    </div>
     <!-- Validation Error Message -->
      <span class="error-message" *ngIf="stockErrors[i]">
        {{ stockErrors[i] }}
      </span>
    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn-cancel" (click)="closeStockModal()">Cancel</button>
      <button class="btn-save" (click)="saveStock()">Save</button>
    </div>

  </div>
</div>